import { GENERATE_COIN_LISTING } from "../../../Types";

var initialValues = [];

const GenerateCoinListingReducer = (state = initialValues, action) => {
  switch (action.type) {
    case GENERATE_COIN_LISTING:
      return action.payload;
    default:
      return state;
  }
};
export default GenerateCoinListingReducer;
